var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 24,
    height: 24,
    fill: "#5e5e5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linked_in",
    "data-name": "linked in"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M510.347,287.232c-2.051,0-2.359,1.607-2.359,3.254v6.282h-3.951v-12.7h3.791v1.738h.048a4.153,4.153,0,0,1,3.739-2.055c4,0,4.729,2.633,4.729,6.049v6.963H512.4V290.6C512.4,289.124,512.37,287.232,510.347,287.232Z",
    transform: "translate(-497.298 -277.769)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 3.958,
    height: 12.695,
    transform: "translate(0.31 6.304)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M499.585,277.769a2.287,2.287,0,1,1-2.287,2.281A2.28,2.28,0,0,1,499.585,277.769Z",
    transform: "translate(-497.298 -277.769)",
    fill: "#5e5e5e"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInGray);
export default __webpack_public_path__ + "static/media/linkedInGray.c754e54820d6b6aad4a7b396455226c7.svg";
export { ForwardRef as ReactComponent };